import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Report } from '../_models/Reports';

@Component({
  selector: 'app-phone0reports-item',
  templateUrl: './phone0reports-item.component.html',
  styleUrls: ['./phone0reports-item.component.scss']
})
export class Phone0reportsItemComponent implements OnInit {
  displayedColumns = ['created_at', 'updated_at', 'status', 'port', 'phone_number'];
  dataSource = new MatTableDataSource<Report[]>();
  @ViewChild(MatSort) sort: MatSort;

  constructor() { }

  @Input('currenReports') 
  set getCurrentReports(currenReports) {
    if (currenReports) {
      this.dataSource.data = currenReports;
      this.dataSource.sort = this.sort;
    }
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/phone-reports/phone0reports-item/phone0reports-item.component.ts